var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 9,
    viewBox: "0 0 9 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "minus-svgrepo-com 1",
    clipPath: "url(#clip0_843_10980)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M7.68081 1.31804C6.83088 0.468082 5.70083 0 4.49884 0C3.29685 0 2.16681 0.468082 1.31688 1.31804C-0.437658 3.0726 -0.437658 5.92743 1.31688 7.68199C2.16681 8.53192 3.29685 9 4.49887 9C5.70086 9 6.83088 8.53192 7.68081 7.68196C8.53076 6.83204 8.99884 5.70199 8.99884 4.5C8.99884 3.29801 8.53076 2.16796 7.68081 1.31804ZM7.10227 7.10345C6.40687 7.79883 5.4823 8.18182 4.49887 8.18182C3.51542 8.18182 2.59084 7.79883 1.89542 7.10345C0.459888 5.6679 0.459888 3.33213 1.89542 1.89657C2.59082 1.20115 3.51539 0.818182 4.49884 0.818182C5.4823 0.818182 6.40687 1.20115 7.10227 1.89655C7.79767 2.59197 8.18066 3.51655 8.18066 4.5C8.18066 5.48345 7.79767 6.40803 7.10227 7.10345Z",
    fill: "#8094AE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M6.95292 4.08984H2.04386C1.81793 4.08984 1.63477 4.27301 1.63477 4.49893C1.63477 4.72486 1.81793 4.90803 2.04386 4.90803H6.95292C7.17885 4.90803 7.36201 4.72486 7.36201 4.49893C7.36201 4.27301 7.17885 4.08984 6.95292 4.08984Z",
    fill: "#8094AE"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_843_10980"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 9,
    height: 9,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.66814bdb857003fd963bce367122e48f.svg";
export { ForwardRef as ReactComponent };